import type { CSSProperties, ReactNode } from "react";

/** One word of a headline, masked so it can rise into place (see .hub-word in hub.css). */
export const Word = ({ children, index }: { children: ReactNode; index: number }) => (
  <span className="hub-word">
    <span style={{ "--i": index } as CSSProperties}>{children}</span>
  </span>
);
